import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

export const advP7PoorRoas: FaireAdvertiserProfileEntity = {
  token: "adv_p7_poor_roas",
  type: "advertiserProfile",
  archetype: "high-spend-poor-roas",
  displayName: "Orchard Lane Provisions",
  brandToken: "b_adv_p7_poor_roas",
  audienceType: "NEW_AND_RETURNING",
  globalStatus: "ACTIVE",
  tenureMonths: 24,
  budget: {
    totalBudgetDollars: 600,
    spendingMode: "CONSERVATIVE",
    nextRenewsAtDate: "2026-08-01",
    nextBillsAtDate: "2026-08-04",
  },
  overview: {
    numCustomersAcquired: 4,
    numReorderConversions: 0,
    numTotalConversions: 4,
    totalAdsSalesDollars: 559,
    newCustomerAdsSalesDollars: 559,
    reorderAdsSalesDollars: 0,
    totalAdsSpendDollars: 224,
    newCustomerAdsSpendDollars: 224,
    reorderAdsSpendDollars: 0,
    newCustomerBestEstimateFirstYearRoas: 2.5,
    reorderRoas: 0,
    combinedFirstYearRoas: 2.5,
  },
  availableCredit: {
    totalRemainingDollars: 0,
  },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 400,
      maxRecommendedBudgetDollars: 600,
    },
    reorder: {
      minRecommendedBudgetDollars: 200,
      maxRecommendedBudgetDollars: 300,
    },
  },
  campaignTokens: ["camp_p7_poor_roas_new", "camp_p7_poor_roas_reorder"],
  overviewPerformancePeriodTokens: [
    "perf_p7_poor_roas_ovw_202602",
    "perf_p7_poor_roas_ovw_202603",
    "perf_p7_poor_roas_ovw_202604",
    "perf_p7_poor_roas_ovw_202605",
    "perf_p7_poor_roas_ovw_202606",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
